import {
  KmsVehicle,
  Services,
} from '../store/slices/timesheet/timesheetPageSlice';

export const handleInitialKmsForError = (services: Services[]) => {
  const filteredServices: Services[] = [];
  const filteredKmsVehicles = [];
  for (let i = 0; i < services.length; i++) {
    const servEx = services[i].serviceExecution;
    filteredServices[i] = {
      serviceExecution: servEx ? { ...servEx } : undefined,
      ...services[i],
    };
  }
  for (let j = 0; j < filteredServices?.length; j++) {
    const kmsVehicles = filteredServices[j].service.kmsVehicles;
    filteredKmsVehicles[j] = [...(kmsVehicles as KmsVehicle[])];
  }
  return filteredKmsVehicles;
};

export const handleLaterKmsForError = (services: Services[]) => {
  const filteredServices: Services[] = [];
  let filteredKmsVehicles: KmsVehicle[] = [];
  let response = true;
  for (let i = 0; i < services.length; i++) {
    filteredServices[i] = {
      serviceExecution: services[i]?.serviceExecution,
      ...services[i],
    };
  }

  for (let j = 0; j < filteredServices?.length; j++) {
    const kmsVehicles = filteredServices[j].service
      ?.kmsVehicles as KmsVehicle[];
    filteredKmsVehicles = [...kmsVehicles];
  }

  for (let k = 0; k < filteredKmsVehicles?.length; k++) {
    if (
      filteredKmsVehicles[k].kmsIni !== null ||
      filteredKmsVehicles[k].kmsIni !== 0
    ) {
      response = false;
    }
    if (
      filteredKmsVehicles[k].kmsEnd !== null ||
      filteredKmsVehicles[k].kmsEnd !== 0
    ) {
      response = false;
    }
  }

  return response;
};
